import { useEffect } from "react"
import useAuth from "../hooks/useAuth"

export default function Section({ section, children }) {
  const { setSection } = useAuth()
  useEffect(() => {
    setSection(section)
  }, [])

  return <>{children}</>
}